import styled from "styled-components";

import { ChatPropsInterface } from "./interfaces";

export const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardCustom = styled.div`
  width: 447px;
  height: 614px;
  /* width: 90%; */
  border-radius: 42px;
  display: block;
  overflow: auto;

  padding: 32px;
  margin-top: 1vh;
  margin-bottom: 1vh;

  background-color: #fff;
  -webkit-box-shadow: -1px 15px 55px -21px rgba(255, 202, 174, 1);
  -moz-box-shadow: -1px 15px 55px -21px rgba(255, 202, 174, 1);
  box-shadow: -1px 15px 55px -21px rgba(255, 202, 174, 1);
`;

export const CardLogo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const CardHeader = styled.div`
  width: 100%;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.div`
  height: 39px;
  margin: 0px;
  font: normal normal normal 35px Circular Std Book;
  color: #F58B1E;
`;

export const SubTitleProtocol = styled.div`
  margin: 0;
  font: normal normal normal 12px Circular Std Book;
  color: #B8B4CC;
`;

export const AttendantContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 0;
`;

export const AttendantName = styled.p`
  margin: 0px;
  font: normal normal normal 15px Circular Std Book;
  color: #454546;
`;

export const Attendant = styled.span`
  font: normal normal normal 12px Circular Std Book;
  color: #B8B4CC;
`;

export const MessageContainer = styled.div`
  width: 100%;
  height: 350px;
  border: 1px solid #F2F2F2;
  border-radius: 11px;
  margin-top: 17px;
  padding: 20px 8px;

  overflow-y: auto;

  ::-webkit-scrollbar-track {
    background-color: #F4F4F4;
  }
  ::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
  }
  ::-webkit-scrollbar-thumb {
      background: #dad7d7;
  }
`;

export const MessageBlock = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: ${(p: ChatPropsInterface) => p.isUserMessage ? "flex-end" : "flex-start"};
`

export const Message = styled.div`
  width: 270px;
  background: ${(p: ChatPropsInterface) => p.isUserMessage ? "#F2F1FA" : "#F6F5FA"}; ;
  border-radius: 16px;
  padding: 12px;
`;

export const MessageText = styled.div`
  font: normal normal normal 12px Circular Std Book;
  color: #454546;
`;

export const MessageFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font: normal normal normal 10px Circular Std Book;
  color: #B8B4CC;
  margin-top: 3px;
`;

export const FormContainer = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

export const Textarea = styled.textarea`
  width: 65%;
  height: 100%;
  resize: none;
  background: #fff;
  color: #454546;
  border-radius: 7px;
  border: 1px solid rgba(194, 194, 194, 0.2);
  font-size: 0.8em;
  font-weight: 300;
  line-height: 1.45;
  outline: none;
  padding: 0.4em 1em 0.4em;
  -webkit-transition: 0.18s ease-out;
  -moz-transition: 0.18s ease-out;
  -o-transition: 0.18s ease-out;
  transition: 0.18s ease-out;

  -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

  &:hover {
    border: 1px solid rgba(255, 169, 89, 0.2);
    -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
  }

  &:focus {
    color: var(--gray);
    border: 1px solid #eea94993;
    -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
  }

  &:disabled {
    background-color: #F6F5FA;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers */
    text-transform: none;
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    text-transform: none;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    text-transform: none;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    text-transform: none;
  }
  &::placeholder {
    /* Recent browsers */
    text-transform: none;
  }
`;

export const SendButtonContainer = styled.div`
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 11px;
`;

export const SendButton = styled.button`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFF;
  border: 1px solid #F2F1FA;
  border-radius: 18px;
  outline: 0;
  font: normal normal normal 12px Circular Std Book;
  color: #B8B4CC;
  text-transform: uppercase;
  transition: all.3s ease;

  &:focus{
    outline: 0;
  }

  &:hover{
    color: #FFF;
    background-color: #F58B1E;
    border: 1px solid #F58B1E;
  }

  &:active{
    color: #FFF;
    background-color: #F58B1E;
    border: 1px solid #F58B1E;
  }
`


export const ButtonContainer = styled.div`
  margin-top: 60px;
`;

export const BackButton = styled.button`
  border: 1px solid #F58B1E;
  outline: none;
  border-radius: 0;
  padding: 9px 20px;
  font: normal normal 600 9px/11px Muli;
  width: 159px;
  font-weight: 600;
  border-radius: 12px;
  background: #FFF;
  color: #F58B1E;
  transition: all.3s ease;
  
  &:hover {
    color: #FFF;
    background-color: #F58B1E;
  }

  &:focus {
    background: #ffa952;
    outline:none !important;
  }
`